import { render, staticRenderFns } from "./ClientPortalEmail.vue?vue&type=template&id=0ac7c59f"
import script from "./ClientPortalEmail.vue?vue&type=script&lang=ts"
export * from "./ClientPortalEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac7c59f')) {
      api.createRecord('0ac7c59f', component.options)
    } else {
      api.reload('0ac7c59f', component.options)
    }
    module.hot.accept("./ClientPortalEmail.vue?vue&type=template&id=0ac7c59f", function () {
      api.rerender('0ac7c59f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/ClientPortalEmail.vue"
export default component.exports